import React, { useRef } from 'react'
import DynamicForm from '@/components/DynamicForm'
import formView from './productProfileFrom'
import { Button } from '@/components/UiElements'
import { OpenCloneProductProfileForm } from './CloneProfile'
import { OpenCloneProductBySKUForm } from './CloneProfileBySKU'

const ProductProfile = ({ item, bound, close, submit, data, change }) => {
  const formRef = useRef(null)
  const saveData = async () => {
    const data = await formRef?.current?.getData()
    if (data) {
      submit(data)
      close()
    }
  }
  return (
    <div className={'py-xl px-xl flex flex-col gap-md'}>
      <DynamicForm ref={formRef} items={formView} defaultValues={data?.[item?.name]} size={'md'} />

      <div className={'pt-md flex flex-row gap-sm justify-end'}>
        <Button
          className={' !flex-row flex'}
          type={'alt'}
          onClick={() => {
            close()
          }}
        >
          <div className={'flex flex-row gap-md'}> Cancel </div>
        </Button>
        <Button
          className={' !flex-row flex'}
          onClick={() => {
            saveData()
          }}
        >
          <div className={'flex flex-row gap-md'}> Create Product Profile </div>
        </Button>
      </div>
    </div>
  )
}

export default ProductProfile

const OpenProductProfileForm = ({ data, change, show, defaultValues }) => {
  return (
    <div className={'flex flex-row gap-md'}>
      {data?.product_profile || defaultValues ? (
        <Button
          type={'alt'}
          className={' !flex-row flex'}
          onClick={() => {
            show()
          }}
        >
          <div className={'flex flex-row gap-md'}>
            <span className={'font-icon-solid'}></span>
            Edit &quot;{data?.product_profile?.product_profile_name || defaultValues?.shape_profile_name}
            &quot;
          </div>
        </Button>
      ) : (
        <Button
          type={'primary'}
          className={' !flex-row flex'}
          onClick={() => {
            show()
          }}
        >
          <div className={'flex flex-row gap-md'}>
            <span className={'font-icon-solid'}>+</span>
            Add Product Profile
          </div>
        </Button>
      )}
      <OpenCloneProductProfileForm change={change} />
      <OpenCloneProductBySKUForm change={change} />
    </div>
  )
}
export { OpenProductProfileForm }
